const setupSearchInput = (searchInput: HTMLInputElement): (() => void) => {
  const clearIcon = searchInput.nextElementSibling as HTMLElement

  const currentVal = searchInput.value

  if (!currentVal) {
    clearIcon.style.opacity = '0'
  }

  searchInput.addEventListener('keyup', handleKeyUp)
  clearIcon.addEventListener('click', clearSearch)

  function handleKeyUp(event: KeyboardEvent): void {
    const target = event.currentTarget as HTMLInputElement

    if (target.value) {
      clearIcon.style.opacity = '1'
    } else {
      clearIcon.style.opacity = '0'
    }
  }

  function clearSearch(): void {
    searchInput.value = ''
    clearIcon.style.opacity = '0'

    // Dispatch a fake keyUp event to notify any keyup listeners
    searchInput.dispatchEvent(new KeyboardEvent('keyup'))
  }

  return () => {
    searchInput.removeEventListener('keyup', handleKeyUp)
    clearIcon.removeEventListener('click', clearSearch)
  }
}

export default (): (() => void) => {
  const unsubscribe: Array<() => void> = []

  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const setupSearchInputs = (): void => {
      const searchInputs = doc.querySelectorAll(
        '[data-behaviour-search="true"]'
      )

      searchInputs.forEach((searchInput) => {
        unsubscribe.push(setupSearchInput(searchInput as HTMLInputElement))
      })
    }

    setupSearchInputs()

    doc.addEventListener('render_async_load', setupSearchInputs)

    doc.addEventListener(
      'turbolinks:visit',
      () => {
        doc.removeEventListener('render_async_load', setupSearchInputs)
        unsubscribe.forEach((fn) => fn())
      },
      { once: true }
    )
  })

  return () => {
    unsubscribe.forEach((fn) => fn())
  }
}
